import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fcedaed0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcedaed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcedaed0')) {
      api.createRecord('fcedaed0', component.options)
    } else {
      api.reload('fcedaed0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fcedaed0&scoped=true", function () {
      api.rerender('fcedaed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/index.vue"
export default component.exports